module.exports = __webpack_public_path__ + "static/media/23-4.ebe51409.mp3";